import React from 'react';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import { AgencyFilters } from 'Shared/models/AgencyFilters';
import { openFile } from 'Shared/utilities/fetchHelpers';
import {InteractiveDTO} from 'Documents/api';
import { Button } from '@material-ui/core';
import { createSnackbar } from 'Core/ducks/snackbar';
import { useDispatch } from 'react-redux';
import { Conflict, NotFound, ServerError, Unauthorized} from 'Core/models/Async';

type InteractiveDocumentProps = {
    interactive: InteractiveDTO;
    selectedAgency: AgencyFilters;
};


const InteractiveDocument = (props: InteractiveDocumentProps) => {
    const { interactive } = props;
    const interactiveUrl = `/api/documents/v1/interactiveForms/${interactive.fId}`;
    const fileExtension = `pdf`;
    const successResponse = `Sucessfully Downloaded!`;

    const dispatch = useDispatch();
    const getInteractiveDoc = (interactive: InteractiveDTO) => {
        dispatch(createSnackbar("Request initiated!"))
        const response = openFile(interactiveUrl, fileExtension, successResponse );
        response.then(value => {
            const pdfResponse: any = value;
            if( typeof pdfResponse === 'string' ){
                dispatch(createSnackbar(successResponse));
            }
            else if(pdfResponse instanceof NotFound){
                dispatch(createSnackbar(pdfResponse.message));
            }
            else if(pdfResponse instanceof Unauthorized){
                dispatch(createSnackbar(pdfResponse.message));
            }
            else if(pdfResponse instanceof Conflict){
                dispatch(createSnackbar(pdfResponse.message));
            }
            else if(pdfResponse instanceof ServerError){
                dispatch(createSnackbar(pdfResponse.message));
            }
            else{
                dispatch(createSnackbar("Unable to download form!"));
            }
        });
    }

    return (
        <>
            {/* <Link to={bulletinUrl} target="_blank" > */}
                <Button
                    id={`bulletins-view-details-btn-${interactive.fId}`}
                    className="primary-action-button"
                    color="primary"
                    onClick={(interactive: InteractiveDTO) => getInteractiveDoc(interactive)}
                    >
                <DescriptionOutlinedIcon color="error"/>
                </Button>
            {/* </Link> */}
        </>
    )
}
export default InteractiveDocument;

